var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useBuildStyleWithTheme } from '@cvent/carina-theme-provider';
var buildStyle = function (_a, _b) {
    var font = _a.font;
    var readingDirection = _b.readingDirection;
    return {
        stepperWrapper: {
            base: __assign({ margin: '-8px 0 0 0', width: '100%' }, readingDirection)
        },
        progressBarWrapper: {
            position: 'relative',
            top: -24
        },
        mobileWrapper: __assign({ height: 56 }, readingDirection),
        mobileProgressBarWrapper: {
            marginBottom: 16
        },
        mobileStepWrapper: {
            display: 'flex',
            flexDirection: 'column'
        },
        chevronWrapper: {
            // TODO: As part of a different ticket, the extra space above the first step's completion bar needs to be
            // removed. This is caused by this margin and was originally added to make up for the shift in first
            // step's name on expansion and collapse due to the circular progress bar that wraps around it in mobile view
            margin: '8px 0 8px auto',
            paddingTop: 4,
            cursor: 'pointer',
            color: font.color.base
        },
        rtl: {
            chevronWrapper: {
                margin: '8px auto 8px 0'
            }
        }
    };
};
var useStyle = function (isRtl) {
    var builtStyle = useBuildStyleWithTheme(buildStyle, { isRtl: isRtl });
    if (!builtStyle) {
        return {
            stepperWrapper: {},
            mobileWrapper: {},
            mobileProgressBarWrapper: {},
            mobileStepWrapper: {},
            chevronWrapper: {}
        };
    }
    var stepperWrapper = builtStyle.stepperWrapper, progressBarWrapper = builtStyle.progressBarWrapper, mobileWrapper = builtStyle.mobileWrapper, mobileProgressBarWrapper = builtStyle.mobileProgressBarWrapper, mobileStepWrapper = builtStyle.mobileStepWrapper, chevronWrapper = builtStyle.chevronWrapper, rtl = builtStyle.rtl;
    return {
        stepperWrapper: __assign({}, stepperWrapper.base),
        mobileWrapper: mobileWrapper,
        mobileProgressBarWrapper: __assign(__assign({}, progressBarWrapper), mobileProgressBarWrapper),
        mobileStepWrapper: mobileStepWrapper,
        chevronWrapper: __assign(__assign({}, chevronWrapper), (isRtl && rtl.chevronWrapper))
    };
};
export default useStyle;
